import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

interface UseGetCommunityPortalDetailsProps {
  community_id: string;
  role: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommunityPortalDetails = async (ID: string, role: string) =>
  await axiosAuth.get(`${GET_COMMUNITIES}/${ID}/portal-detail?role=${role}`);

const useGetCommunityPortalDetails = ({
  community_id,
  role,
  queryParams,
}: UseGetCommunityPortalDetailsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["community-dtl", community_id, role],
    queryFn: () => getCommunityPortalDetails(community_id, role),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!community_id && (queryParams?.enabled ?? true),
  });
};

export default useGetCommunityPortalDetails;
